<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wYUySe/tc-custom/9781621369127.jpg?1731352499699" alt="This image is the cover for the book Tienes que atreverte"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tienes que atreverte
      </h1>
      <p class="bookDescription body article font2">
        <b>¿Para qué estoy aquí? ¿Cuál es mi propósito?</b><br/> <br/> A través de los siglos, millones de personas se han hecho estas preguntas.  La respuesta, aunque no todos estén dispuestos a aceptarla, es: Estamos aquí para servir a Dios y hacer su voluntad.  Muchos desean saber qué Dios va a hacer por ellos, pero lo que deberían preguntarse es qué Dios va a hacer a través de ellos.<br/> <br/> Nacemos, vivimos y morimos.  No podemos hacer nada sobre el nacer y morir, pero podemos hacer mucho sobre cómo vivimos.  A través de las páginas de <i>Tienes que atreverte</i>, Joyce Meyer invita a abrazar la vida con pasión.  No obstante, esa pasión tiene que tener un propósito.  Ella te ayuda a determinar tu propósito y descubrir la pasión que lo enciende.  Encontrarás la razón por lo que estás en la tierra y el papel que te toca ejercer, así como los factores que te desvían del propósito.<br/> <br/> <b>Tienes que atreverte identifica ocho maneras que distraen a las personas de su propósito</b>:<br/> - Preocupación<br/> - Culpa<br/> - Tratar de controlar lo que sólo Dios puede<br/> - Quejas<br/> - Enojo<br/> - Temor<br/> - Reproche<br/> - Comparación<br/> <br/> Joyce Meyer ofrece puntos de acción como: "Verifique sus motivos", "Haga lo que ama", y ¡Sueñe en grande!.  Al descubrir lo que vigoriza e inspira tu mente, tu cuerpo y espíritu, y encontrar dirección y enfoque para tus finanzas, emociones y energías, recibirás la determinación para realizar cabalmente tu potencial.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joyce Meyer
      </h2>
      
      <p class="authorDescription body article">Joyce Meyer es una de las maestras de la Biblia líderes en el mundo. Su programa diario, Disfrutando la vida diaria, se transmite por cientos de canales de televisión y estaciones de radio en todo el mundo. Joyce ha escrito más de 100 libros inspiradores. Algunos de sus éxitos de ventas son: La batalla es del Señor, Una vida sin conflictos, Cómo oír a Dios, El campo de batalla de la mente para jóvenes y El campo de batalla de la mente para niños, entre otros. Joyce viaja extensamente, teniendo congresos a lo largo del año, hablando a miles de personas alrededor del mundo.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Charisma Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c336224e